import React from "react";

const BaseErrorNotification = ({ content, events }) => {
  const { onDismiss } = events;
  return (
    <div className="ui small error icon message">
      <i aria-hidden="true" className="close icon" onClick={onDismiss}></i>
      <i aria-hidden="true" className="remove circle icon"></i>
      <div className="content">
        <div className="header">Error</div>
        {content}
      </div>
    </div>
  );
};
export default BaseErrorNotification;
